export default "__VITE_ASSET__HG1bysda__"